


























































































import { Component, Vue } from 'vue-property-decorator';
import BaseVue from '@/core/BaseVue';
import GenericEdit from '@/core/Generics/GenericEdit';
import Language from "@/models/language/language.model";
@Component
export default class LanguageEdit extends GenericEdit<Language> {
  constructor() {
    super();
    this.controller = 'Languages';
    this.model = new Language();
  }
}
